// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__2Ka7m","spin":"Spinner_spin__1T5Wy","container":"Spinner_container__LWkuR"};